import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

import CollapsablePanel from 'Common/Components/controlled-collapsable-panel/ControlledCollapsablePanel';
import YearSelector from 'Common/Components/year-selector/YearSelector.container';
import ActionButton from 'Common/Buttons/ActionButton';
import styles from './filter.module.css';
import StartWithSelector from './StartWithSelector/StartWithSelector';
import TeamTypeSelector from './TeamTypeSelector/TeamTypeSelector';

const TeamTypeFilterView = ({
	open,
	togglePanel,
	grouping,
	updateYear,
    year,
    numberOfPreviousYears,
    numberOfFutureYears,
	startWith,
	setStartWith,
    showStartWith,
	types,
	allTypes,
	updateTypes,
	teams,
	allTeams,
	updateTeams,
	handleNewFilter,
	handleGo,
	refining,
	setRefining
}) => {
	const isValid = value => value === 'Type' || value === 'Team';

	const typeProps = {
		itemName: 'Type',
		selected: types,
		allItems: allTypes,
		updateSelected: updateTypes
	};

	const teamProps = {
		itemName: 'Team',
		selected: teams,
		allItems: allTeams,
		updateSelected: updateTeams
	};

	const getSelectorConfig = () => {
		if (startWith === 'Type') {
			return {
				first: typeProps,
				second: { ...teamProps, allItems: [...allTeams] },
				firstSelections: [...types]
			};
		} else if (startWith === 'Team') {
			return {
				first: teamProps,
				second: { ...typeProps, allItems: [...allTypes] },
				firstSelections: [...teams]
			};
		}
		return {
			first: {
				allItems: []
			},
			second: {
				allItems: []
			},
			firstSelections: []
		};
	};

	const { first, second, firstSelections } = getSelectorConfig();
	const secondHasItems = second.allItems.length > 0;
	const showGoButton = firstSelections.length > 0;

	return (
			<CollapsablePanel open={open} onClick={togglePanel}>
				<CollapsablePanel.Closed>
					<div className={styles['filter-closed']}>
						<Typography variant="h3">Filter</Typography>
						<ActionButton text="New Filter" onClick={handleNewFilter} containerClass={styles['new-filter-button']}></ActionButton>
					</div>
				</CollapsablePanel.Closed>

				<CollapsablePanel.Open>
					<div className={styles['filter-open']}>
						<Typography variant="h3">Filter</Typography>
                    <YearSelector grouping={grouping} updateYear={updateYear} year={year} numberOfPreviousYears={numberOfPreviousYears} numberOfFutureYears={numberOfFutureYears} />
						{showStartWith && <StartWithSelector onChange={setStartWith} value={startWith} />}
						{isValid(startWith) && (
							<div className={styles.container}>
								<div className={styles.selectors}>
									<TeamTypeSelector isStartWith={true} {...first} refining={true} setRefining={()=>{}} />
									{secondHasItems && <TeamTypeSelector isStartWith={false} {...second} refining={refining} setRefining={setRefining} />}
								</div>
								{showGoButton && <ActionButton text="Go" onClick={handleGo} />}
							</div>
						)}
					</div>
				</CollapsablePanel.Open>
			</CollapsablePanel>
	);
};

TeamTypeFilterView.propTypes = {
	open: PropTypes.bool.isRequired,
	togglePanel: PropTypes.func.isRequired,
	grouping: PropTypes.string.isRequired,
	updateYear: PropTypes.func.isRequired,
    year: PropTypes.string,
    numberOfPreviousYears: PropTypes.number,
    numberOfFutureYears: PropTypes.number,
	startWith: PropTypes.string.isRequired,
	setStartWith: PropTypes.func.isRequired,
    showStartWith: PropTypes.bool.isRequired,
	allTeams: PropTypes.array.isRequired,
	allTypes: PropTypes.array.isRequired,
	types: PropTypes.object.isRequired,
	teams: PropTypes.object.isRequired,
	updateTypes: PropTypes.func.isRequired,
	updateTeams: PropTypes.func.isRequired,
	handleNewFilter: PropTypes.func.isRequired,
	handleGo: PropTypes.func.isRequired,
	refining: PropTypes.bool.isRequired,
	setRefining: PropTypes.func.isRequired
};

export default TeamTypeFilterView;
